import React, { useState, useCallback, useEffect, useRef } from 'react';
import { Formik } from 'formik';
import styled from 'styled-components';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import TextField from '@material-ui/core/TextField';
import FormGrid from '../../../components/Form/FormGrid';
import { Title2 } from '../../../components/Typography';
import PhoneNumber from '../../../layout/components/PhoneNumber';
import StickyErrorMessageBox from '../../../components/ErrorMessage/StickyErrorMessageBox';
import AuthCode, { AuthCodeRef } from 'react-auth-code-input';
import _ from 'lodash';
import parsePhoneNumber from 'libphonenumber-js';
import { PrimaryButton } from '../../../components/Buttons';
import { makeStyles } from '@material-ui/core/styles';
import appConfig from '../../../../app-config';

const useStyles = makeStyles({
  underline: {
    '&&&:before': {
      borderBottom: 'none',
    },
    '&&:after': {
      borderBottom: 'none',
    },
  },
});
const Button = styled(PrimaryButton)`
  min-width: 0px;
  width: 175px;
  margin-top: 10px;
`;
const VerificationAndChangeNumberWrapper = styled.div`
  margin-top: 28px;
  /* padding: 0 50px; */
`;

const ErrorMessageWrapper = styled.div`
  padding: 0;
  margin: 0;
  width: 440px;
  @media (max-width: 786px) {
    width: 100%;
  }
`;
const ModalWrapper = styled.div`
  width: 400px;
  padding: 20px;
  background: white;
  margin: auto;
  display: grid;
  grid-gap: 10px;
  @media (max-width: 786px) {
    padding: 24px 20px;
    width: 100%;
  }
`;

const TitleWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  grid-gap: 10px;
`;

const Cancel = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  color: white;
  background-color: rgba(81, 78, 89, 0.63);

  right: 8px;
  top: 8px;
  z-index: 99;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &:hover {
    background: ${(props) => props.theme.closeButtonHoverColor};
    transition: all 0.25s ease;
  }
`;

const VerifyButton = styled.div`
  cursor: pointer;
  margin-right: auto;
  color: ${(props) => props.theme.clickableTextColor};
  font-family: ${(props) => props.theme.primaryFontFontFamily};

  &:hover {
    text-decoration: underline;
    color: ${(props) => props.theme.clickableTextColorHover};
    transition: all 0.25s ease;
  }
`;

const MessageWrapper = styled.p`
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  color: #000000;
  margin-bottom: 40px;
  padding: 0 25px;
`;
const ActionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 24px;
`;
const Action = styled.div`
  font-family: 'Inter';
  font-size: 19px;
  font-weight: 600;
  color: #002760;
  margin-bottom: 24px;
  cursor: pointer;
`;
const MessageContainer = styled.div`
  height: 100px;
`;

const styles = (theme) => ({
  scrollPaper: {
    alignItems: 'flex-start',
  },
  paper: {
    position: window.innerWidth < 786 ? 'absolute' : 'static',
    bottom: 0,
    left: 0,
    margin: 0,
    marginTop: window.innerWidth < 786 ? 0 : '338px',
    width: window.innerWidth < 786 ? '100%' : '440px',
    height: window.innerWidth < 786 ? '210px' : null,
    maxWidth: '100%',
    borderRadius: '12px',
    borderBottomLeftRadius: window.innerWidth < 786 ? 0 : '12px',
    borderBottomRightRadius: window.innerWidth < 786 ? 0 : '12px',
  },
  input: {
    fontFamily: theme.typography.fontFamily.main,
  },
});

const ConfirmSMSForm = ({
  isRequesting,
  confirmSMS,
  handleBackButtonClick,
  setPatchPhoneNumberIsVisible,
  patchPhoneNumberIsVisible,
  classes,
  setPhoneNumber,
  phoneNumber,
  updatePhoneNumber,
  updatePhoneNumberButtonIsDisabled,
  authErrors,
  enteredEmail,
  setEnteredEmail,
  enteredPhoneNumber,
  setEnteredPhoneNumber,
  selectedCategoryId,
  actionType,
  loginObject,
  setLoginObject,
  login,
  resendRegistrationCode,
  setSelectedCategoryId,
  isPasswordLess,
  clearAuthErrorMessage,
  isCodeCleared,
  clearVerificationCode,
  unconfirmedPhone,
  errors,
  setErrors,
  setLoyaltyRegistrationModalOpen,
}) => {
  const AuthInputRef = useRef(AuthCodeRef);
  useEffect(() => {
    if (Object.keys(errors).length > 0) {
      AuthInputRef.current.clear();
    }
  }, [errors]);
  useEffect(() => {
    if (isCodeCleared) {
      AuthInputRef.current.clear();
    }
  }, [isCodeCleared]);
  const [latitude, setLatitude] = useState();
  const [longitude, setLongitude] = useState();
  const [resendMethod, setResendMethod] = useState();
  const [verifyButtonText, setVerifyButtonText] = useState();
  const [displayPhoneInput, setDisplayPhoneInput] = useState();
  const [verfiyModalMessage, setVerfiyModalMessage] = useState('');
  const [verificationSource, setVerificationSource] = useState();
  useEffect(() => {
    navigator.geolocation.getCurrentPosition(function(position) {
      setLatitude(position.coords.latitude);
      setLongitude(position.coords.longitude);
    });
    return () => {
      clearAuthErrorMessage();
    };
  }, []);
  useEffect(() => {
    if (isCodeCleared) {
      // setEnteredPhoneNumber(unconfirmedPhone);
      setVerificationSource(unconfirmedPhone);
    } else {
      if (enteredPhoneNumber?.length > 9) {
        const phone = parsePhoneNumber(
          '+1' + enteredPhoneNumber
        ).formatNational();
        setVerificationSource(phone);
      }
      if (enteredEmail) {
        setVerificationSource(enteredEmail);
      }
    }
  }, [enteredEmail, enteredPhoneNumber, isCodeCleared]);

  const [confirmCode, setConfirmCode] = useState();
  const handleOnChange = (code) => {
    setConfirmCode(code);
  };
  const sendCode = () => {
    if (
      (isPasswordLess && confirmCode?.length === 6) ||
      (!isPasswordLess && confirmCode?.length === 4)
    ) {
      if (actionType === 'login' && !isCodeCleared) {
        let payload;
        if (enteredEmail) {
          payload = {
            email: enteredEmail,
            source: appConfig.appSource,
            verification_code: confirmCode,
            platform_id: 3,
            latitude: latitude || 0,
            longitude: longitude || 0,
          };
        } else if (enteredPhoneNumber) {
          payload = {
            phone_number: enteredPhoneNumber,
            source: appConfig.appSource,
            verification_code: confirmCode,
            platform_id: 3,
            latitude: latitude || 0,
            longitude: longitude || 0,
          };
        }
        confirmSMS(payload, 'login');
        AuthInputRef.current.clear();
      } else {
        const newConfirmCodeObject = { sms_code: confirmCode };
        confirmSMS(newConfirmCodeObject, 'registration');
        AuthInputRef.current.clear();
      }
    }
  };
  useEffect(() => {
    sendCode();
  }, [confirmCode]);
  const getSecondMessage = () => {
    let message;
    if (actionType === 'login') {
      if (enteredEmail) {
        message = 'Send via SMS instead';
      } else if (enteredPhoneNumber) {
        message = 'Send via Email Instead';
      }
    } else {
      message = 'Use a Different Phone Number';
    }
    return message;
  };
  const resendCode = () => {
    if (actionType === 'login') {
      const newLoginObject = { ...loginObject };
      if (resendMethod === 'phone') {
        delete newLoginObject.email;
        setEnteredEmail(null);
        newLoginObject.phone_number = enteredPhoneNumber;
        login(
          newLoginObject,
          setSelectedCategoryId,
          setPatchPhoneNumberIsVisible
        );
      } else if (resendMethod === 'email') {
        delete newLoginObject.phone_number;
        setEnteredPhoneNumber(null);
        newLoginObject.email = enteredEmail;
        login(
          newLoginObject,
          setSelectedCategoryId,
          setPatchPhoneNumberIsVisible
        );
      } else {
        login(loginObject, setSelectedCategoryId, setPatchPhoneNumberIsVisible);
      }
    } else {
      const resendObject = {
        phone_number: enteredPhoneNumber,
        platform_id: 3,
        // source: appConfig.appSource,
      };
      resendRegistrationCode(resendObject, setPatchPhoneNumberIsVisible);
      AuthInputRef.current.clear();
    }
    setErrors({});
  };
  const showVerifyModal = (type) => {
    let title;
    let isPhoneVisible;
    let verifyButtonText;
    let currentResendMethod;
    if (actionType === 'login') {
      if (type === 'resend') {
        if (enteredEmail) {
          isPhoneVisible = false;
          title = 'Verify Email Address';
        } else if (enteredPhoneNumber) {
          isPhoneVisible = true;
          title = 'Verify Phone Number';
        }
        verifyButtonText = 'Resend Code';
      } else {
        if (enteredEmail) {
          isPhoneVisible = true;
          title = 'Verify Phone Number';
          currentResendMethod = 'phone'; //opposite of the current one.
        } else if (enteredPhoneNumber) {
          isPhoneVisible = false;
          title = 'Verify Email Address';
          currentResendMethod = 'email';
        }
        verifyButtonText = 'Resend Code';
      }
    } else {
      if (type === 'resend') {
        isPhoneVisible = true;
        title = 'Verify Phone Number';
        verifyButtonText = 'Resend Code';
      } else {
        isPhoneVisible = true;
        title = 'Update Phone Number';
        verifyButtonText = 'Resend Code';
      }
    }
    if (currentResendMethod) {
      setResendMethod(currentResendMethod);
    }
    setVerifyButtonText(verifyButtonText);
    setDisplayPhoneInput(isPhoneVisible);
    setVerfiyModalMessage(title);
    setPatchPhoneNumberIsVisible(true);
  };

  const isEmailFormatValid = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };
  return (
    <form>
      <FormGrid>
        <VerificationAndChangeNumberWrapper>
          <MessageContainer>
            {selectedCategoryId === 1 && enteredEmail && (
              <MessageWrapper>
                If there is an account linked to
                <span style={{ display: 'inline-block', marginRight: '5px' }}>
                  {verificationSource}
                </span>
                , you will receive a verification code. Please enter it below
              </MessageWrapper>
            )}
            {selectedCategoryId === 1 && enteredPhoneNumber && (
              <MessageWrapper>
                If there is an account linked to
                <span
                  style={{
                    display: 'inline-block',
                    marginRight: '5px',
                  }}
                >
                  {verificationSource}
                </span>
                , you will receive a verification code. Please enter it below
              </MessageWrapper>
            )}
            {selectedCategoryId !== 1 && (
              <MessageWrapper>
                We sent a verification code to
                <span
                  style={{
                    display: 'inline-block',
                    marginRight: '5px',
                    marginLeft: '5px',
                  }}
                >
                  {verificationSource}
                </span>
                in order to ensure a secure sign-up. Please enter the code
                below.
              </MessageWrapper>
            )}
          </MessageContainer>
          <AuthCode
            containerClassName='verification-input-container'
            inputClassName='verification-input'
            allowedCharacters='numeric'
            onChange={handleOnChange}
            length={isPasswordLess ? 6 : 4}
            ref={AuthInputRef}
          />
          <ActionWrapper>
            <Action onClick={() => showVerifyModal('resend')}>
              Resend Code
            </Action>

            {/* <Action onClick={() => showVerifyModal('change')}>
              {getSecondMessage()}
            </Action> */}
          </ActionWrapper>
        </VerificationAndChangeNumberWrapper>
      </FormGrid>
      {patchPhoneNumberIsVisible && (
        <Dialog
          open={patchPhoneNumberIsVisible}
          onBackdropClick={() => setPatchPhoneNumberIsVisible(false)}
          fullWidth={window.innerWidth < 786}
          fullScreen={window.innerWidth < 786}
          // classes={{ scrollPaper: classes.scrollPaper }}
          PaperProps={{ classes: { root: classes.paper } }}
          scroll='body'
        >
          {authErrors && Object.keys(authErrors).length > 0 && (
            <ErrorMessageWrapper>
              <StickyErrorMessageBox
                errors={authErrors}
                marginTop='0'
                messageWidth='100%'
              />
            </ErrorMessageWrapper>
          )}
          <ModalWrapper>
            <TitleWrapper>
              <Title2 id='Registration-Title'>{verfiyModalMessage}</Title2>
              <Cancel
                id='Registration-CancelButton'
                onClick={() => {
                  setPatchPhoneNumberIsVisible(false);
                  clearAuthErrorMessage();
                }}
              >
                <i className='fal fa-times' />
              </Cancel>
            </TitleWrapper>
            {displayPhoneInput ? (
              <PhoneNumber
                id='Registration-PhoneNumber'
                label='Phone Number'
                name='phoneNumber'
                handlePhone={(value) => setEnteredPhoneNumber(value)}
              />
            ) : (
              <TextField
                id='EmailForm-Username'
                label={'Email'}
                name='email'
                type='email'
                autoComplete='username'
                value={enteredEmail}
                onChange={(e) => setEnteredEmail(e.target.value)}
                required
                // onBlur={handleBlur}
                // error={touched.email && errors.email ? true : false}
                // helperText={touched.email && errors.email}
                InputLabelProps={{
                  className: classes.input,
                  required: false,
                  style: { color: '#a9a9a9' },
                }}
              />
            )}
            <div style={{ margin: '0 auto' }}>
              <Button
                id='Registration-UpdateButton'
                disabled={
                  (!enteredEmail && !enteredPhoneNumber) ||
                  (enteredPhoneNumber && enteredPhoneNumber?.length < 10) ||
                  (enteredEmail && !isEmailFormatValid(enteredEmail))
                }
                type='button'
                onClick={resendCode}
              >
                {verifyButtonText}
              </Button>
            </div>
          </ModalWrapper>
        </Dialog>
      )}
    </form>
  );
};

export default withStyles(styles)(ConfirmSMSForm);
